import { AppController } from "@lib/titan2-slingo/dist/game/controller/AppController";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AppEvent } from "@lib/titan2/dist/game/Constants";
/**
 * Game-specific override which doesn't dispatch IDLE on DAB_ACTIVE, instead dispatching BUSY as this game has auto dabs.
 */
export class GameAppController extends AppController {
    addEventListeners() {
        super.addEventListeners();
        this.unregisterGame(SlingoEvent.DAB_ACTIVE);
        this.registerGame(SlingoEvent.DAB_ACTIVE, this.handleAutoDabActive);
    }
    handleAutoDabActive() {
        this.dispatchCore(AppEvent.BUSY);
    }
}
//# sourceMappingURL=GameAppController.js.map